import {ENDPOINT_ANALYTICS} from 'common/endpoints';
import {commonJwtHeader} from 'common/utils';

const getAnalyticsReportsInfo = (token) => {
  return fetch(`${ENDPOINT_ANALYTICS}reports/`, {
    method: 'GET',
    headers: commonJwtHeader(),
  });
};

export default {getAnalyticsReportsInfo};
